import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from 'src/app/@core/components/ui/button/button.component';
import { BrowserExtensionService } from 'src/app/@core/services/browser-extension.service';
import { ToastService } from 'src/app/@core/services/toast.service';
import { AssetUrlPipe } from 'src/app/@shared/pipes/asset-url.pipe';
import { SanitizeHtmlPipe } from 'src/app/@shared/pipes/sanitizeHtml.pipe';
import { INTEGRATION_TYPE } from 'src/app/contract-management/models/integration-types.enum';
import { IntegrationsService } from 'src/app/contract-management/services/integrations.service';
import { MISC_CONNECTORS, TOOLKIT_PROVIDERS } from 'src/app/features/general-agent/constants/tool.constants';
import { GeneralAgentService } from 'src/app/features/general-agent/services/general-agent.service';
import { DatabaseConnectionComponent } from '../database-connection/database-connection.component';


@Component({
  selector: 'app-default-integration-dialog',
  standalone: true,
  imports: [ButtonComponent, CommonModule, SanitizeHtmlPipe, DatabaseConnectionComponent, AssetUrlPipe],
  templateUrl: './default-integration-dialog.component.html',
  styleUrl: './default-integration-dialog.component.scss'
})
export class DefaultIntegrationDialogComponent {
  INTEGRATION_TYPE = INTEGRATION_TYPE;

  @Input() integration: {
    key: string;
    value: string;
    name: string;
    description: string;
    imgPath?: string;
    imgSvgPath?: string;
    connected?: boolean;
    data?: {
      connectionUrl?: string;
      host?: string;
      port?: string;
      database?: string;
      username?: string;
      password?: string;
    }
  } = {
      key: '',
      value: '',
      name: '',
      description: '',
      imgPath: '',
      connected: false
    };

  @Output() close = new EventEmitter<{ connected?: boolean; statusChanged?: boolean }>();

  constructor(private integrationsService: IntegrationsService,
    private toast: ToastService,
    private generalAgentService: GeneralAgentService,
    private browserExtensionService: BrowserExtensionService
  ) {
  }

  dots = Array(5).fill(0);
  isConnecting = false;
  isDisconnecting = false;

  onConnect() {
    if (this.integration.value === MISC_CONNECTORS.MY_BROWSER) {
      this.browserExtensionService.goToExtensionUrl();
      return;
    }
    this.isConnecting = true;
    this.integrationsService.addConnector({ toolKit: this.integration.value as TOOLKIT_PROVIDERS, callbackUrl: "settings/integrations/callback" }).subscribe((res) => {
      if (res.data.status) {
        this.toast.success('Connection initiated successfully');
        if (res.data.redirectUrl) {
          window.location.href = res.data.redirectUrl;
        }
      } else {
        this.toast.error('Connection failed', 'Connection failed');
        this.isConnecting = false;
      }
    });
  }

  onDisconnect() {
    if (this.integration.value === MISC_CONNECTORS.MY_BROWSER) {
      this.browserExtensionService.goToExtensionUrl();
      return;
    }
    this.isDisconnecting = true;
    this.integrationsService.disconnectIntegration({
      key: this.integration.key,
      value: this.integration.value,
    }).subscribe((res: any) => {
      if (res.success) {
        this.toast.success('Integration disconnected successfully!');
        this.integration.connected = false;
        this.close.emit({ connected: false, statusChanged: true });
      }
    });
  }

  onClose(event?: { connected?: boolean }) {
    if (event) {
      this.integration.connected = event.connected || false;
      this.close.emit(event);
    } else {
      this.close.emit({ connected: this.integration.connected });
    }
  }

}
